/*
  Shared four-button information panels.
  - Nothing is open on page load (panels are server-rendered hidden).
  - Clicking a button opens only that panel.
  - Clicking the active button again, the Close control, or Escape closes it.
  Event delegation keeps it working when the theme re-renders the product
  info area (variant changes) or a section reloads in the theme editor.
*/
(() => {
  if (window.__rtaInfoPanels) return;
  window.__rtaInfoPanels = true;

  const closeAll = (root) => {
    root.querySelectorAll('[data-rta-info-button]').forEach((button) => {
      button.setAttribute('aria-expanded', 'false');
    });
    root.querySelectorAll('[data-rta-info-panel]').forEach((panel) => {
      panel.hidden = true;
    });
    const win = root.querySelector('[data-rta-info-window]');
    if (win) win.hidden = true;
  };

  const open = (root, button) => {
    const key = button.getAttribute('data-rta-info-button');
    button.setAttribute('aria-expanded', 'true');
    root.querySelectorAll('[data-rta-info-panel]').forEach((panel) => {
      panel.hidden = panel.getAttribute('data-rta-info-panel') !== key;
    });
    const win = root.querySelector('[data-rta-info-window]');
    if (win) win.hidden = false;
  };

  const activeButton = (root) => root.querySelector('[data-rta-info-button][aria-expanded="true"]');

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-rta-info-button]');
    if (button) {
      const root = button.closest('[data-rta-info]');
      if (!root) return;
      const wasOpen = button.getAttribute('aria-expanded') === 'true';
      closeAll(root);
      if (!wasOpen) open(root, button);
      return;
    }

    const close = event.target.closest('[data-rta-info-close]');
    if (close) {
      const root = close.closest('[data-rta-info]');
      if (!root) return;
      const active = activeButton(root);
      closeAll(root);
      if (active) active.focus();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const root = event.target.closest && event.target.closest('[data-rta-info]');
    if (!root) return;
    const active = activeButton(root);
    if (!active) return;
    closeAll(root);
    active.focus();
  });
})();
